import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
  background-color: #881d158f;
  backdrop-filter: blur(10px);
`;

export const Content = styled.div`
  position: relative;
  color: white;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`;

export const ContainerMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 12px 16px;
  gap: 1rem;

  @media (max-width: 540px) {
    flex-direction: column;
    text-align: center;
    padding: 8px 12px;
  }
`;

export const Paragraph = styled.p`
  color: black;
  font-size: 15px;
  margin: 0;

  @media (max-width: 750px) {
    font-size: 12px;
  }

  @media (max-width: 540px) {
    font-size: 12px;
  }
`;
